/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        17/01/2022 16:54
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export const CROSS_ACTIVE_CLASS = 'active'
export const MENU_IS_OPEN_CLASS = 'menu-is-open'
export const SUBMENU_IS_OPEN_CLASS = 'submenu-is-open'
